<template>
    <div class="separator bg-tertiary py-6 my-6">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'Separator',
}
</script>

<style lang="scss" scoped>
$border-color: $secondary-color;
.separator {
    border: 1px solid $border-color;
    border-left: $spacing-unit-12 solid $border-color;
}
</style>
